import React from "react";

export default function LeadCategory({ score }) {

let label = "Cold";
let color = "var(--color-cold)";
let bgColor = "var(--color-cold-light)";

if(score > 64){
label = "Hot";
color = "var(--color-hot)";
bgColor = "var(--color-hot-light)";
}
else if(score > 39){
label = "Warm";
color = "var(--color-warm)";
bgColor = "var(--color-warm-light)";
}

return (

<span
style={{
padding:"4px 10px",
borderRadius:"6px",
fontWeight:600,
fontSize:"13px",
background:bgColor,
color:color
}}
>
{label}
</span>

);

}